import PropTypes from 'prop-types';

import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

const Answering = ({ children }) => (
  <div className="absolute top-0 flex items-center pt-2 text-neutral-low-300 dark:text-neutral-high-100">
    <Icon className="mr-2" name="reply-filled" size="size3" />
    <Text size="size2">{children}</Text>
  </div>
);

Answering.propTypes = {
  children: PropTypes.string.isRequired,
};

export default Answering;
